import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import SelectDropdown from "../components-react/SelectDropdown";
import { showConfirmAlert } from "../components-react/ReactAlert";
import { commonPostPutApi } from "../../redux/reducers/commonApiSlice";
import { addLead } from "../../data/ApiEndpoints";
import { validateEditForm } from "./functions/LeadValidations";
import {
  fetchInHouseUsersData,
  fetchLeadSourceData,
  fetchReceptionistBySlotData,
} from "../../redux/reducers/dropdownApiSlice";
import { fetchGymData } from "../../data/APIs";
import { selectGymData } from "../../redux/reducers/gymDataSlice";
import { leadSources, timeSlots } from "../common-data/DropdowData";
import CloseSubmitBtn from "../common-components/custom-comps/CloseSubmitBtn";
import { objectToQueryString } from "../common-data/Conversions";

const LeadEditForm = ({
  userInfoData,
  closeModal,
  callFunction,
  isEdit,
  rowData,
}) => {
  const dispatch = useDispatch();
  const gymData = useSelector(selectGymData);
  const {
    receptionistBySlot,
    leadSources: dynamic_lead_sources,
    inhouseUsers,
  } = useSelector((state) => state.dropdown);
  const { postPutLoadingFormData } = useSelector((state) => state.common);

  const isAdmin = userInfoData?.account_type === "admin";

  const iniFormValues = {
    addedById: userInfoData?.user_id || userInfoData?.uid || "",
    custName: isEdit && rowData?.name ? rowData.name : "",
    custMobile: isEdit && rowData?.mobile ? rowData.mobile : "",
    leadValueAmount: rowData?.lead_value ? rowData.lead_value : 0,
    selectedGym:
      isEdit && rowData?.gym_name && rowData?.gym_id
        ? {
            label: rowData?.gym_name,
            value: rowData?.gym_id,
          }
        : !isAdmin
        ? {
            label: userInfoData?.gym_name,
            value:
              userInfoData?.gym_id ||
              userInfoData?.user_id ||
              userInfoData?.uid ||
              "",
          }
        : "",
    selectedSlot: "",
    selectedReceptionist:
      isEdit && rowData?.assigned_to_name && rowData?.assigned_to_id
        ? {
            label: rowData?.assigned_to_name,
            value: rowData?.assigned_to_id,
          }
        : "",
    selectedSource:
      isEdit && rowData?.source_name
        ? {
            label: rowData.source_name?.replace(/_/g, " "),
            value: rowData.source_name,
          }
        : "",
    assignToOtherUsers: false,
    selectedOtherUser: "",
  };
  const [formValues, setFormValues] = useState(iniFormValues);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);

  const onChangeInput = (e) => {
    const { name, value } = e.target;

    setIsSubmit(false);

    setFormValues((prevs) => ({
      ...prevs,
      [name]: value,
    }));
  };

  const onChangeDropdown = (name, value) => {
    if (name === "selectedGym" || name === "selectedSlot") {
      setFormValues((prev) => ({
        ...prev,
        [name]: value,
        selectedReceptionist: "",
      }));
    } else {
      setFormValues((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const onChangeCheckbox = (e) => {
    const { name, checked } = e.target;
    setFormValues((prev) => ({
      ...prev,
      [name]: checked,
      selectedSlot: "",
      selectedReceptionist: "",
      selectedOtherUser: "",
    }));
  };

  const onSumitForm = (e) => {
    e.preventDefault();

    setFormErrors(validateEditForm(formValues, rowData));
    setIsSubmit(true);
  };

  function getReceptionistBySlot(filter) {
    dispatch(
      fetchReceptionistBySlotData({
        filters: filter,
        token: userInfoData?.token,
      })
    );
  }

  function getOtherUsers(filter) {
    const finalQP = objectToQueryString(filter);

    dispatch(
      fetchInHouseUsersData({
        token: userInfoData?.token,
        qps: finalQP,
        pageNo: 1,
        limit: 100,
      })
    );
  }

  function getLeadSources(filters) {
    dispatch(
      fetchLeadSourceData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  const handleAddLead = async (payload) => {
    const method = "PUT";
    const endpoint = addLead;
    const token = userInfoData?.token || "";

    try {
      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      if (result?.payload?.status) {
        setIsSubmit(false);
        closeModal();
        callFunction();
        toast.success(result?.payload?.message || "Success!");
      } else {
        const errorMessage = result?.payload?.message || result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  useEffect(() => {
    setFormValues((prevs) => ({
      ...prevs,
      custName: isEdit && rowData?.name ? rowData.name : "",
      custMobile: isEdit && rowData?.mobile ? rowData.mobile : "",
      leadValueAmount: rowData?.lead_value ? rowData.lead_value : 0,
      selectedGym:
        isEdit && rowData?.gym_name && rowData?.gym_id
          ? {
              label: rowData?.gym_name,
              value: rowData?.gym_id,
            }
          : !isAdmin
          ? {
              label: userInfoData?.gym_name,
              value:
                userInfoData?.gym_id ||
                userInfoData?.user_id ||
                userInfoData?.uid ||
                "",
            }
          : "",
      selectedReceptionist:
        isEdit && rowData?.assigned_to_name && rowData?.assigned_to_id
          ? {
              label: rowData?.assigned_to_name,
              value: rowData?.assigned_to_id,
            }
          : "",
      selectedSource:
        isEdit && rowData?.source_name
          ? {
              label: rowData.source_name?.replace(/_/g, " "),
              value: rowData.source_name,
            }
          : "",
    }));
  }, []);

  useEffect(() => {
    dispatch(fetchGymData(userInfoData?.token));
  }, []);

  useEffect(() => {
    const filters = {
      limit: 2000,
      page: 1,
      is_rawlead: 0,
    };

    getLeadSources(filters);
  }, []);

  useEffect(() => {
    const [start, end] = formValues.selectedSlot?.value
      ? formValues.selectedSlot.value.split("-")
      : "";

    const filters = {
      gym_id: formValues.selectedGym?.value || "",
      slot_start_time: start || "",
      slot_end_time: end || "",
    };

    getReceptionistBySlot(filters);
  }, [formValues.selectedSlot, formValues.selectedGym]);

  useEffect(() => {
    if (formValues.assignToOtherUsers) {
      const filters = {
        user_types:
          "admin,cluster_manager,fitness_manager,sales_manager,club_manager",
      };

      getOtherUsers(filters);
    }
  }, [formValues.assignToOtherUsers]);

  useEffect(() => {
    if (isSubmit && Object.keys(formErrors)?.length === 0) {
      const userData = {
        added_by: formValues.addedById || "",
        lead_id: rowData.lead_id || "",
        mobile: formValues.custMobile || "",
        lead_value: formValues.leadValueAmount || 0,
        duration: formValues.selectedPlan?.value || "",
        gym_id: formValues.selectedGym?.value || "",
        assigned_to: formValues.assignToOtherUsers
          ? formValues.selectedOtherUser?.value || ""
          : formValues.selectedReceptionist?.value || "",
        source_name: formValues.selectedSource?.value || "",
      };

      const handleConfirm = async () => {
        handleAddLead(userData);
      };

      showConfirmAlert(
        handleConfirm,
        `You want update this lead - ${rowData?.name || ""}?`,
        "No, Cancel",
        "Yes, Update"
      );
    }
  }, [isSubmit, formErrors]);

  console.log("formErrors=> ", formErrors);

  return (
    <div className="form-container">
      <form className="formContainer">
        <div className="formInputsGrid twoGridSystem">
          <div className="formInputBox">
            <label htmlFor="custName" className={`formInputLabel`}>
              Customer Name
            </label>

            <input
              type="text"
              className="formInput"
              name="custName"
              placeholder={`🚫 ${formValues.custName || "NA"}`}
              disabled
            />
          </div>

          <div className="formInputBox">
            <label htmlFor="custMobile" className={`formInputLabel`}>
              Customer Mobile <span className="required">*</span>
            </label>

            <input
              type="number"
              placeholder="Enter Customer Mobile Number"
              className={`formInput ${
                formErrors?.custMobile ? "formError" : ""
              }`}
              name="custMobile"
              value={formValues.custMobile}
              onChange={onChangeInput}
              min={0}
            />
          </div>

          {rowData?.cutomer_intent === "interested" ? (
            <div className="formInputBox">
              <label htmlFor="leadValueAmount" className={`formInputLabel`}>
                Lead Value <span className="required">*</span>
              </label>

              <input
                type="number"
                placeholder="Enter Amount"
                className={`formInput ${
                  formErrors?.leadValueAmount ? "formError" : ""
                }`}
                name="leadValueAmount"
                value={formValues.leadValueAmount}
                onChange={onChangeInput}
                min={0}
              />
            </div>
          ) : null}

          <div className="formInputBox">
            <label htmlFor="selectedGym" className={`formInputLabel `}>
              Gym <span className="required">*</span>
            </label>

            <div
              className={`commonWrapper ${
                formErrors.selectedGym ? "formError" : ""
              }`}
            >
              <SelectDropdown
                options={gymData?.length > 0 ? gymData : []}
                selectedOption={formValues.selectedGym}
                setSelectedOption={(selectedValue) =>
                  onChangeDropdown("selectedGym", selectedValue)
                }
                name="Gym"
              />
            </div>
          </div>

          {!formValues.assignToOtherUsers && (
            <>
              <div className="formInputBox">
                <label htmlFor="selectedSlot" className="formInputLabel">
                  Select Slot To Fetch Sales Executive
                </label>

                <div
                  className={`commonWrapper ${
                    formErrors.selectedSlot && "formError"
                  }`}
                >
                  <SelectDropdown
                    options={timeSlots}
                    selectedOption={formValues.selectedSlot}
                    setSelectedOption={(selectedValue) =>
                      onChangeDropdown("selectedSlot", selectedValue)
                    }
                    name="Slot"
                  />
                </div>
              </div>

              <div className="formInputBox">
                <label
                  htmlFor="selectedReceptionist"
                  className={`formInputLabel`}
                >
                  Sales Executive <span className="required">*</span>
                </label>

                <div
                  className={`commonWrapper ${
                    formErrors.selectedReceptionist ? "formError" : ""
                  }`}
                >
                  <SelectDropdown
                    options={
                      receptionistBySlot?.length > 0 ? receptionistBySlot : []
                    }
                    selectedOption={formValues.selectedReceptionist}
                    setSelectedOption={(selectedValue) =>
                      onChangeDropdown("selectedReceptionist", selectedValue)
                    }
                    name="Sales Executive"
                  />
                </div>

                {formValues.selectedSlot && receptionistBySlot?.length === 0 ? (
                  <span className="info">{`No Sales Executive Availble In The Slot ${
                    formValues.selectedSlot?.label || ""
                  }, select different slot!`}</span>
                ) : null}
              </div>
            </>
          )}

          {formValues.assignToOtherUsers && (
            <div className="formInputBox">
              <label htmlFor="selectedOtherUser" className={`formInputLabel`}>
                Select User <span className="required">*</span>
              </label>

              <div
                className={`commonWrapper ${
                  formErrors.selectedOtherUser ? "formError" : ""
                }`}
              >
                <SelectDropdown
                  options={inhouseUsers?.length > 0 ? inhouseUsers : []}
                  selectedOption={formValues.selectedOtherUser}
                  setSelectedOption={(selectedValue) =>
                    onChangeDropdown("selectedOtherUser", selectedValue)
                  }
                  name="User"
                />
              </div>
            </div>
          )}

          {!rowData?.is_raw_lead && (
            <div className="formInputBox">
              <label htmlFor="selectedSource" className={`formInputLabel`}>
                Source Name <span className="required">*</span>
              </label>

              <div
                className={`commonWrapper ${
                  formErrors.selectedSource ? "formError" : ""
                }`}
              >
                <SelectDropdown
                  options={
                    dynamic_lead_sources?.data?.length > 0
                      ? dynamic_lead_sources.data
                      : leadSources
                  }
                  selectedOption={formValues.selectedSource}
                  setSelectedOption={(selectedValue) =>
                    onChangeDropdown("selectedSource", selectedValue)
                  }
                  name="Source"
                  preventKeyboardOpen={true}
                />
              </div>
            </div>
          )}

          <div className="formInputBox span2 mt15">
            <label className="formInputLabel checkboxLabel">
              <input
                type="checkbox"
                name="assignToOtherUsers"
                checked={formValues.assignToOtherUsers}
                onChange={onChangeCheckbox}
              />
              Assign To Other Users
            </label>
          </div>
        </div>

        <CloseSubmitBtn
          submitLabel={"Update"}
          closeLabel="Cancel"
          onSubmit={onSumitForm}
          onClose={closeModal}
          isLoading={postPutLoadingFormData}
        />
      </form>
    </div>
  );
};

export default LeadEditForm;
